import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import type { AdminUser, LMAdminUser } from 'typings'
import { useFetch } from './useFetch'

export function useAdminUser(options?: Partial<UseQueryOptions<AdminUser>>) {
  const { fetcherWrapper } = useFetch()

  async function fetcher() {
    return fetcherWrapper(`/api/proxy/license-manager/user/profile`)
      .then((r) => r.json())
      .then((profile: LMAdminUser): AdminUser => {
        return {
          id: profile.id,
          email: profile.email,
          internalUser: profile.email.includes('@vtex.com'),
        }
      })
  }

  return useQuery<AdminUser>({
    queryKey: ['admin-user'],
    queryFn: fetcher,
    ...options,
  })
}
